export default __webpack_public_path__ + "static/media/annotationIcon-light.acc63618.svg";